import * as React from 'react'
import ReactMapboxGl, { Popup, Marker } from 'react-mapbox-gl';
import environmentHelper from 'src/share/utils/environmentHelper';
import { redMarker } from "../images/red-marker";
import { stringDateToLongFormat } from 'src/share/utils/utils';

const source = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(redMarker);

const Map = ReactMapboxGl({
  accessToken: environmentHelper.getReactMapboxGlConfig(),
  interactive: false
});

function PDMap({ child }): React.ReactElement {
  return (
    <div className="partners-dashboard__map box">
      <Map
        style="mapbox://styles/mapbox/streets-v9"
        containerStyle={{
          height: '100%',
          width: '100%'
        }}
        zoom={[6]}
        flyToOptions={{
          speed: 1,
          curve: 1,
        }}
        center={child.center}
      >
        {child &&
          <Marker coordinates={[child.center.lng, child.center.lat]} anchor="bottom" style={{ width: '1.5rem', height: '1.5rem' }}>
            <img src={source} alt="Location Marker" />
          </Marker>
        }
        {child &&
          <Popup coordinates={[child.center.lng, child.center.lat]} offset={15}>
            <div className="marker__modal">
              <img src={child.photo} alt="Child Photo" />
              <div>
                {child.location}.
              <p>{stringDateToLongFormat(child.missingDate)}</p>
              </div>
            </div>
          </Popup>
        }
      </Map>
    </div>
  )
}

export default PDMap;


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Partners/components/PDMap.tsx